import { PulseBaseProvider } from '../../base-classes';
const _clientLoggingUri = '/clog/v1/submit';

export class ClientLoggingProvider extends PulseBaseProvider {
	constructor(baseUrl, authId, secret, options, logger) {
		super(baseUrl, authId, secret, options, logger);
	}

	async postClientEvent(eventData, stdParameters) {
		const queryParams = {
			...stdParameters,
		};

		const data = JSON.stringify(eventData);

		return await super.postData(queryParams, data, _clientLoggingUri, true, null);
	}
}
